import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'createArray',
})
export class CreateArrayPipe implements PipeTransform {
  transform(value: number, fillValue?: any): any {
    return Array(value).fill(fillValue !== undefined ? fillValue : 1);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/pipes/create-array.pipe.ts